<template>
  <div class="min-h-screen flex flex-col">
    <HomeNavbar />
    <slot />
    <TheWhatsappButton />
  </div>
</template>
